export interface DeviceInfo {
  isIOS: boolean;
  isSafari: boolean;
  isMobile: boolean;
  isAndroid: boolean;
  isWebView: boolean;
  isNative: boolean;
  platform: "ios" | "android" | "web";
  userAgent: string;
}

const DEFAULT_DEVICE_INFO: DeviceInfo = {
  isIOS: false,
  isSafari: false,
  isMobile: false,
  isAndroid: false,
  isWebView: false,
  isNative: false,
  platform: "web",
  userAgent: "",
};

export function detectDeviceInfo(): DeviceInfo {
  if (typeof navigator === "undefined") {
    return DEFAULT_DEVICE_INFO;
  }

  const userAgent = navigator.userAgent;

  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

  const isMobile =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent,
    ) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  const isAndroid = /Android/i.test(userAgent);

  const isWebView = (() => {
    if (/sysigreja-mobile\//i.test(userAgent)) {
      return true;
    }

    if (typeof (window as Window & { ReactNativeWebView?: unknown }).ReactNativeWebView !== "undefined") {
      return true;
    }

    // Chrome/Firefox/Edge no iOS usam WKWebView, mas são navegador de verdade.
    // `webkit.messageHandlers` existe neles e não pode marcar WebView.
    if (/CriOS|FxiOS|EdgiOS|OPiOS/i.test(userAgent)) {
      return false;
    }

    if (isAndroid && /; wv\)/i.test(userAgent)) {
      return true;
    }

    if (isIOS && !/Safari/i.test(userAgent) && /Mobile/i.test(userAgent)) {
      return true;
    }

    if (
      document.referrer.includes("android-app://") ||
      document.referrer.includes("ios-app://")
    ) {
      return true;
    }

    return false;
  })();

  return {
    isIOS,
    isSafari,
    isMobile,
    isAndroid,
    isWebView,
    isNative: false,
    platform: "web",
    userAgent,
  };
}

let cachedDeviceInfo: DeviceInfo | null = null;

export function getDeviceInfo(): DeviceInfo {
  if (!cachedDeviceInfo) {
    cachedDeviceInfo = detectDeviceInfo();
  }
  return cachedDeviceInfo;
}
